import { createFileRoute, Outlet } from "@tanstack/react-router";
import type { FC } from "react";
import { ForbiddenError } from "../../../../errors/ForbiddenError";

const RouteComponent: FC = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_private/vsupplierregistration/vendors")(
  {
    beforeLoad({ context }) {
      if (!context.auth.user?.vendor) {
        return;
      }

      throw new ForbiddenError();
    },
    component: RouteComponent,
  },
);
